import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from "@angular/router";
import { Injectable } from "@angular/core";
import { BaseApiGuard } from "./base-api.guard";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class InfoportalApiGuard extends BaseApiGuard  {


  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
        if (this.perms.UserCan_InfoportalAPI && (route.url.length == 0 || this._CanAccessSubRoute(route.url[0]))) {
          return true;
        }
        this.NavigateToFallbackModule();
        return false;
  }
  private _CanAccessSubRoute(url: UrlSegment): boolean {
    if (this.userService.CurrentUser.internalAccess) { return true; }
    switch (url.path.toLowerCase()) {
      case "infoportal": return true;
      case "anlagen": return true;
      default: return false;
    }
  }
}
